import * as Yup from "yup";
import { validateCharacterLimitWithContext } from "../../../helpers/formBodyCharacterLimitValidation";


// Helper function to create schema with dynamic character limit
export const createPostSchema = (maxCharacters: number) => {
  const today = new Date();
  const futureMaxDate = new Date(today);
  futureMaxDate.setMonth(futureMaxDate.getMonth() + 3);

  return Yup.object().shape({
    title: Yup.string().required("Debes indicar el nombre de la artículo."),
    body: Yup.string()
      .nullable()
      .required("Agrega una descripción a tu artículo.")
      .test(
        'character-limit',
        'No puedes usar más de caracteres', // El mensaje se maneja dinámicamente en la función
        function (value) {
          return validateCharacterLimitWithContext.call(this, value, 10000); // 1000 caracteres máximo
        }
      ),
    attached_files: Yup.array().nullable(),
    attached_url: Yup.string().nullable(),
    content_categories: Yup.array().of(Yup.number()).nullable(),
    notificate_by_email: Yup.array().of(Yup.string()).nullable(),
    notificate_by_telegram: Yup.array().of(Yup.string()).nullable(),
    pinned: Yup.array().of(Yup.string()).nullable(),
    show_scheduled_post: Yup.array().of(Yup.string()).nullable(),
    is_free: Yup.array().of(Yup.string()).nullable(),
    group: Yup.number().required(),
    block_files_download: Yup.array().of(Yup.string()).nullable(),
    schedule_publish_at: Yup.date().when('action_publish_at', {
      is: 'scheduled_publication',
      then: Yup.date()
        .min(today, "Debes indicar una fecha futura")
        .max(futureMaxDate, "Puedes programar la publicacion hasta un máximo de 3 meses en el futuro")
        .required("Debes completar la fecha y hora en que quieres que se publique el artículo"),
      otherwise: Yup.date().nullable(),
    }),
    short_description: Yup.string().nullable().max(120, "La descripción debe tener menos de 120 caracteres"),
    ask_for_phone: Yup.array().of(Yup.string()).nullable(),
  });
};